(function(){
  // Variable para evitar inicializaciones múltiples
  var initialized = false;
  
  // Función principal
  function initAnimatedCounters() {
    // Evita inicializar más de una vez
    if (initialized) return;
    initialized = true;
    
    // Buscamos los contadores
    var counters = document.querySelectorAll('#animated-counter .counter');
    if (!counters.length) return;
    
    // Configuración
    var duration = 2000; // Duración fija en milisegundos para todos los contadores
    var framerate = 1000/60; // 60 FPS
    
    // Función para animar un contador específico
    function animateCounter(counter) {
      var target = parseInt(counter.getAttribute('data-target'), 10);
      if (isNaN(target)) return;
      
      var start = 0;
      var startTime = null;
      
      // Función optimizada de animación usando requestAnimationFrame
      function updateCounter(timestamp) {
        if (!startTime) startTime = timestamp;
        
        var progress = Math.min((timestamp - startTime) / duration, 1);
        
        // Función de ease-out para hacer la animación más natural
        var easedProgress = 1 - Math.pow(1 - progress, 3);
        
        // Calcular el valor actual redondeado
        var currentValue = Math.round(easedProgress * target);
        
        // Actualizar el contador solo si el valor ha cambiado
        if (currentValue !== start) {
          counter.textContent = currentValue;
          start = currentValue;
        }
        
        // Continuar animando si no hemos llegado al objetivo
        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        } else {
          // Asegurarnos de que el valor final es exactamente el target
          counter.textContent = target;
        }
      }
      
      // Iniciar la animación
      requestAnimationFrame(updateCounter);
    }
    
    // Verificar si el navegador soporta IntersectionObserver
    if ('IntersectionObserver' in window) {
      var options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2 // Disparar cuando el 20% del elemento es visible
      };
      
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target); // Dejar de observar después de iniciar la animación
          }
        });
      }, options);
      
      // Observar cada contador
      counters.forEach(function(counter) {
        observer.observe(counter);
      });
    } else {
      // Fallback para navegadores que no soportan IntersectionObserver
      counters.forEach(function(counter) {
        animateCounter(counter);
      });
    }
  }
  
  // Iniciar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimatedCounters);
  } else {
    initAnimatedCounters();
  }
  
  // Reiniciar cuando el usuario cambia de pestaña y vuelve
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
      initialized = false;
      initAnimatedCounters();
    }
  });
})();
  